export enum ParkingPaymentVendor {
    PayByXCanada,
    PayByXUS,
    LimestoneRealEstate,
    LimestoneService,
    PayByPhoneLotID,
    ImparkLotID
}
